<template lang="pug">
  include ./../../mixins
  +b.table-invoice
    +e.TABLE
      +e.thead.THEAD
        +e.TR
          +e.th--id.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('id')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) ORDER ID
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('created_at')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) ORDER CREATED
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('date_at')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) BOOKING DATE
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('price')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) TOTAL PRICE
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('prepayment')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) DEPOSIT AMOUNT
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('paid')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) DEPOSIT STATUS
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) PHONE
          +e.th--link.TH
            +e.info-wrapper
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) LINK
      +e.TBODY
        +e.TR(
          v-for="(item, index) in objectList"
          :key="`${item.id}/${index}`"
        )
          +e.td--id.TD
            +b.text--fw_medium.--fs_xs.--color_blue.ROUTER-LINK(
              :to="{ name: 'BalanceDetailsCabinet', params: { from: 'statistics', id: item.id } }"
            ) {{ item.id || '-' }}
          +e.td--id.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.createdAt || '-' }}
          +e.td--id.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.dateAt || '-' }}
          +e.td--id.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.price || '-' }}
          +e.td--id.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.prepayment || '-' }}
          +e.td--id.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.paid || '-' }}
          +e.td--id.TD
            +e.info-wrapper
              +b.TEXT-BEMTO(
                :fw="'medium'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) {{ item.phone || '-' }}
              +e.icon-copy.icon--type_copy(
                v-if="item.link"
                v-clipboard:copy="item.phone"
                @click.prevent="copyPhoneHandler"
              )
          +e.td--link.TD
            +b.button--copy.BUTTON(
              v-if="item.link"
              v-clipboard:copy="item.link"
              @click.prevent="copyLinkHandler"
            )
              +b.icon--type_copy.I
            +b.TEXT-BEMTO(
              v-if="!item.link"
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) -
</template>

<script>
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'

export default {
  name: 'StatisticsTable',
  mixins: [
    ToggleModalMixin,
  ],
  props: [
    'objectList',
  ],
  data() {
    return {
      ordering: '-',
    }
  },
  methods: {
    setOrderHandler(key) {
      if (this.ordering.includes('-')) {
        this.ordering = key
      } else {
        this.ordering = `-${key}`
      }
    },
    async changeSort(key) {
      await this.setOrderHandler(key)
      this.$emit('ordering', this.ordering)
    },
    copyPhoneHandler() {
      this.toggleToster(
        'Phone copied'
      )
    },
    copyLinkHandler() {
      this.toggleToster(
        'Link copied'
      )
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Tables/StatisticsTable.vue